{
  "version": 1,
  "asset_id": "24f5e3ea-4a70-42ff-ba01-9bc8322e3b02",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/24f5e3ea-4a70-42ff-ba01-9bc8322e3b02/foreignaffairs-semrush-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/24f5e3ea-4a70-42ff-ba01-9bc8322e3b02/foreignaffairs-semrush-640.avif",
  "original_filename": "foreignaffairs-semrush-640.avif",
  "size": 10123,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:32Z"
}
